package it.maicol07.spraypaintkt

import it.maicol07.gamerlogue.`data`.Activity
import it.maicol07.gamerlogue.`data`.AppNotification
import it.maicol07.gamerlogue.`data`.Block
import it.maicol07.gamerlogue.`data`.Comment
import it.maicol07.gamerlogue.`data`.Follow
import it.maicol07.gamerlogue.`data`.LibraryEntry
import it.maicol07.gamerlogue.`data`.Reaction
import it.maicol07.gamerlogue.`data`.Report
import it.maicol07.gamerlogue.`data`.User
import it.maicol07.gamerlogue.`data`.UserList
import it.maicol07.gamerlogue.`data`.UserListItem

public fun ResourceRegistry.registerResources() {
  registerResource<LibraryEntry>(LibraryEntry.Companion)
  registerResource<UserList>(UserList.Companion)
  registerResource<UserListItem>(UserListItem.Companion)
  registerResource<Comment>(Comment.Companion)
  registerResource<Activity>(Activity.Companion)
  registerResource<AppNotification>(AppNotification.Companion)
  registerResource<Report>(Report.Companion)
  registerResource<Follow>(Follow.Companion)
  registerResource<Block>(Block.Companion)
  registerResource<Reaction>(Reaction.Companion)
  registerResource<User>(User.Companion)
}
